<p-panel header="Account Notes" toggler="header" [toggleable]="true" [(collapsed)]="collapsed" (collapsedChange)="expandPanel($event)">
  <ng-template #headericons let-collapsed>
    <i class="pi pi-chevron-right duration-150" [class]="{ 'rotate-90': !collapsed }"></i>
  </ng-template>

  <div class="flex justify-end gap-2 mb-3">
    <button
      pButton
      label="Clear All Filters"
      class="mr-2"
      [disabled]="showExistingNote"
      (click)="clearFilters()"
    ></button>
    <button
      pButton
      label="Add Note"
      class="p-button-outlined p-accordion-button"
      icon="pi pi-plus"
      [disabled]="showExistingNote"
      (click)="openNotes()"
    ></button>
  </div>


  <p-table
    #dt
    aria-label="Account Notes table"
    class="table-parameters table-paginator"
    sortField="sortField"
    [alwaysShowPaginator]="true"
    [columns]="cols"
    [paginator]="true"
    [sortOrder]="sortOrder"
    [totalRecords]="totalRecords"
    [rows]="10"
    [loading]="isLoading"
    [value]="notesDetails"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th class="w-16"></th>
        <th style="min-width: 20rem" pSortableColumn="activityType">
          <div class="flex items-center gap-2">
            Activity Type
            <p-sortIcon field="activityType"></p-sortIcon>
          </div>
        </th>
        <th style="min-width: 10rem" pSortableColumn="requestSource">
          <div class="flex items-center gap-2">
            Request Source
            <p-sortIcon field="requestSource"></p-sortIcon>
          </div>
        </th>
        <th style="max-width: 14rem" pSortableColumn="note">Note</th>
        <th style="min-width: 20rem" pSortableColumn="createdBy">
          <div class="flex items-center gap-2">
            Created By
            <p-sortIcon field="createdBy"/>
          </div>
        </th>
        <th style="min-width: 16rem" pSortableColumn="createdOn">
          <div class="flex items-center gap-2">
            Created On
            <p-sortIcon field="createdOn"></p-sortIcon>
          </div>
        </th>
      </tr>
      <tr class="header-filter">
        <th class="w-16"></th>
        <th style="min-width: 20rem">
          <p-multiSelect
            [options]="activityTypes"
            [(ngModel)]="selectedActivityTypes"
            (onChange)="onChangeFilter('activityType', selectedActivityTypes)"
            placeholder="Filter"
            appendTo="body"
          />
        </th>
        <th style="min-width: 10rem">
          <p-multiSelect
            [options]="requestSources"
            [(ngModel)]="selectedRequestSources"
            (onChange)="onChangeFilter('requestSource', selectedRequestSources)"
            placeholder="Filter"
            appendTo="body"
          />
        </th>
        <th style="min-width: 14rem">
          <p-iconfield>
            <p-inputicon class="pi pi-search" />
            <input
              class="w-full"
              pInputText type="text"
              placeholder="Search"
              [(ngModel)]="noteSearch"
              (ngModelChange)="onTextFilter('note', noteSearch)" />
          </p-iconfield>
        </th>
        <th style="min-width: 20rem">
          <p-multiSelect [options]="createdByList" [(ngModel)]="selectedCreatedBy"
                         (onChange)="onChangeFilter('createdBy', selectedCreatedBy)" placeholder="Filter"
                         styleClass="max-w-64" appendTo="body">
          </p-multiSelect>
        </th>
        <th style="max-width: 16rem">
          <p-date-picker
            [(ngModel)]="selectedCreatedOnDate"
            (ngModelChange)="onChangeFilter()"
            dateFormat="mm/dd/yy"
            placeholder="mm/dd/yyyy hh:mm:ss"
            [panelStyle]="{ 'width': '360px' }"
            appendTo="body"
            [showIcon]="true"
            [showButtonBar]="true"
          />
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item let-columns="columns">
      <tr [pSelectableRow]="item">
        <td class="w-16 py-0!">
          <p-button (onClick)="openNoteDialog(item.noteId)" icon="pi pi-external-link" [rounded]="true" [text]="' '">
          </p-button>
        </td>
        <td>{{ item.activityType }}</td>
        <td>{{ item.requestSource }}</td>
        <td>
          @if (item.note.length > 50) {
            <span title="{{ item.note }}">
                  {{ item.note | slice:0:50 }}...
              </span>
          }
          @if (item.note.length <= 50) {
            <span>{{ item.note }}</span>
          }
        </td>
        <td>{{ item.createdBy }}</td>
        <td>{{ item.createdOn | date:'MM/dd/yyyy hh:mm:ss a' }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns="columns">
      <tr>
        <td class="w-full" colspan="8">
          No records found.
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-panel>

<p-dialog
  header="New Note"
  appendTo="body"
  styleClass="note-dialog"
  maximizeIcon="pi pi-arrow-up-right-and-arrow-down-left-from-center"
  minimizeIcon="pi pi-arrow-down-left-and-arrow-up-right-to-center"
  (onHide)="onCloseDialog()"
  [visible]="showNewNote && !isExisting"
  [modal]="false"
  [closable]="true"
  [maximizable]="true"
  [resizable]="true"
  [style]="{ width: '536px' }"
  (onMaximize)="onMaximize()"
  (visibleChange)="onDialogVisibilityChange($event)"
>
  <h5 class="font-semibold text-xl mb-4">Account Note</h5>
  @if (!isExisting && showNewNote) {
    <app-account-note
      [userData]="userData"
      [_isNoteEditable]="isEditable"
      (cancelClicked)="onCloseDialog()"
      [showNote]="showNewNote"
      (noteSaved)="handleNoteSaved($event)"
    />
  }
</p-dialog>

<p-dialog
  header="Note"
  appendTo="body"
  styleClass="note-dialog"
  maximizeIcon="pi pi-arrow-up-right-and-arrow-down-left-from-center"
  minimizeIcon="pi pi-arrow-down-left-and-arrow-up-right-to-center"
  (onHide)="onCloseExistingDialog()"
  [visible]="showExistingNote"
  [modal]="false"
  [closable]="true"
  [maximizable]="true"
  [resizable]="true"
  (visibleChange)="onExistingDialogVisibilityChange($event)"
  [style]="{ minWidth: '536px'}"
  (onMaximize)="onMaximize()"
>
  @if (isExisting && showExistingNote && noteDetails) {
    <div>
      <h5 class="font-semibold text-xl mb-4">Account Note</h5>
      <app-account-note
        [userData]="userData"
        [_isNoteEditable]="isEditable"
        [isExisting]="isExisting"
        [noteDetails]="noteDetails"
        (cancelClicked)="onCloseExistingDialog()"
        [showNote]="showExistingNote"
        (noteSaved)="handleNoteSaved($event)"
      />
    </div>
  }
</p-dialog>
<p-toast key="noteStatus" position="center"></p-toast>
